import React from "react";
import {Box, Grid} from "@mui/material";
import Paper from '@mui/material/Paper';
import LanguageSelect from "@/pages/auth/Login/components/MainLayout/LanguageSelect";

type LayoutProps = {
  image: React.ReactNode;
  children: React.ReactNode;
}

const styles = {
  container: {
    width: '100%',
    height: '100%',
    margin: 0,
    backgroundImage: "url(/images/login-background.svg)",
    backgroundRepeat: 'no-repeat',
    backgroundSize: "cover",
    // backgroundPositionY: -96,
    // backgroundPositionX: 16
  },
  option: {
    display: 'flex',

  }
}
const MainLayout: React.FC<LayoutProps> = (props) => {
  return (
    <Grid
      container
      sx={styles.container}
    >
      <Grid item lg={7} xs={6}/>
      <Grid item lg={5} xs={6} >
        <LanguageSelect />
        <Paper sx={{backgroundColor: "rgba(255,255,255,0.7)", width: '34vw', borderRadius: "20px", marginLeft: '40px'}} elevation={0}>
          <Grid>
            {props.children}
          </Grid>
        </Paper>
      </Grid>
   </Grid>
  )
}
export default MainLayout
